import logErrorToMyService from './logErrorToMyService';
import appState from '../storages/mobx/appState';

function sendNotification(title, options, onClick) {
  // Проверим, поддерживает ли браузер HTML5 Notifications
  if (!('Notification' in window)) {
    alert('Ваш браузер не поддерживает уведомления, его необходимо обновить.');
  }
  // Проверим, есть ли права на отправку уведомлений
  else if (Notification.permission === 'granted') {
    // Если права есть, отправим уведомление
    const notification = new Notification(title, options);
    notification.onclick = onClick;
  }
  // Если прав нет, пытаемся их получить
  else if (Notification.permission !== 'denied') {
    Notification.requestPermission((permission) => {
      // Если права успешно получены, отправляем уведомление
      if (permission === 'granted') {
        const notification = new Notification(title, options);
        notification.onclick = onClick;
      } else {
        appState.setNotificationStatus(false);
        logErrorToMyService('User disable notifications', []);
        // alert('Вы запретили показывать уведомления'); // Юзер отклонил наш запрос на показ уведомлений
      }
    });
  } else {
    // Пользователь ранее отклонил наш запрос на показ уведомлений
    // В этом месте мы можем, но не будем его беспокоить. Уважайте решения своих пользователей.
    appState.setNotificationStatus(false);
    logErrorToMyService('User disable notifications', []);
    // alert('Вы запретили показывать уведомления');
  }
}

export {
  sendNotification,
};
